<script>
import { Calendar } from 'element-ui';
const CalendarWrapper = Calendar;
CalendarWrapper.name = 'JskCalendar';
export default CalendarWrapper;
</script>

<style lang="scss" scoped>
@import '../../plugins/theme-variables.scss';
</style>
